export default __webpack_public_path__ + "static/media/abaf_sessao_03.9aa25406.png";